import {
  alpha,
  Box, Grid, IconButton, Paper, Stack, Typography, useTheme
} from "@mui/material";
import usePasswordRecoveryForm from "./usePasswordRecoveryForm";
import {Link} from "react-router-dom";
import I18n from "i18n-js";
import {Button, Field, FieldsContainer, Form, FormToolbar, PasswordField, Spacer, TextField} from "common";
import React from "react";
import {styled} from "@mui/system";
//@ts-ignore
import {ReactComponent as ReactLogo} from "assets/logo.svg";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {PasswordRecoveryForm as DefaultValueProp} from './passwordRecoveryAPI';

const Logo = styled(ReactLogo)`
    max-height: 70px;
    min-height: 70px;
`;

interface PasswordRecoveryFormProps {
  token: string;
  onPasswordChanged: Function;
}

export default function PasswordRecoveryForm({token, onPasswordChanged}: PasswordRecoveryFormProps) {
  const theme = useTheme();
  const {
    item,
    errors,
    loading,
    process,
    onChange,
  } = usePasswordRecoveryForm({defaultValues: {} as DefaultValueProp, token, onPasswordChanged});

  return (
    <Box
      flex={1}
      flexDirection="column"
      display="flex"
      alignItems="center"
      //justifyContent="center"
      padding={4}
    >
      <Grid container justifyContent="center">
        <Grid
          item
          xs={12}
          sx={{
            justifyContent: "center",
            display: "flex",
          }}
        >
          <Paper
            sx={{
              padding: 4,
              maxWidth: "sm",
              backgroundColor: theme =>
                alpha(theme.palette.background.paper, 0.95),
            }}
            elevation={5}
          >
            <Link to={"/login"}>
              <IconButton>
                <ChevronLeftIcon/>
              </IconButton>
            </Link>
            <Stack spacing={2} sx={{alignItems: "center"}}>
              <Link
                to="/"
                style={{
                  color: theme.palette.mode === "dark" ? "white" : "#001e3c",
                }}
              >
                <Logo/>
              </Link>
              <Typography variant="h2">{I18n.t("App.title")}</Typography>
              <Typography variant="h5">{I18n.t("PasswordRecovery.title")}</Typography>
            </Stack>
            <Spacer h={4}/>
            <Form
              item={item}
              errors={errors}
              onChange={onChange}
              translationCategory="PasswordRecovery.attributes"
            >
              <FieldsContainer>
                <Field xs={12}>
                  <PasswordField
                    id={"password"}
                    onEnter={process}
                  />
                </Field>
              </FieldsContainer>
            </Form>
            <Spacer h={2}/>
            <FormToolbar variant="dense">
              <Spacer right/>
              <Button
                variant="contained"
                loading={loading}
                fullWidth
                onClick={() => process()}
              >
                {I18n.t("PasswordRecovery.reset")}
              </Button>
            </FormToolbar>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}